export const loginTypeMap = {
    EXPIRED: 0, // 登录态失效
    GRABBED: 1 // 登录态被踢
};